import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {ManageBadgesView} from 'views/admin/ManageBadges';

export const ManageBadges = () => {
  useDocumentTitle('Badges');
  return <ManageBadgesView />;
};
